// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-modal .modal-dialog {\n  max-width: 300px;\n  width: 90%;\n}\n", ""]);
// Exports
module.exports = exports;
